import { ProductCategory } from '@graphql/generated';

export const OFFERS_CATEGORY: Pick<ProductCategory, 'id' | 'name'> = {
  id: 'offer',
  name: 'Ofertas'
};
